// extracted by mini-css-extract-plugin
export default {"container":"lZ-z","list":"mZ-z"};